/**
 * @prettier
 * @author Alexander Nagelberg
 * @author Steven Wiggins (minor updates)
 *
 **/
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { fetchRefundTotals, clearRefunds } from '../actions/fundingfeeActions'
import RefundRecordsTable from '../components/RefundRecordsTable'
import SearchForm from '../components/SearchForm'
import RefundTotals from '../components/RefundTotals'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import { URLs } from '../utils/refundUtils'

const RefundSearchContainer = ({ fetchRefundTotals, clearRefunds, fundingFee }) => {
  useEffect(() => {
    clearRefunds()
  }, [clearRefunds])

  // If there's only one search result, redirect to refund
  if (fundingFee?.refunds?.length === 1) {
    return <Redirect to={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/${fundingFee.refunds[0].id}`} />
  }

  return (
    <div className='lgy-funding-fee-refund-search'>
      <SearchForm onSubmit={fetchRefundTotals} form='funding-fee-search' />
      {fundingFee.fetching && <LgyLoadingIcon />}
      {fundingFee.refunds && (
        <>
          <RefundTotals />
          <RefundRecordsTable refunds={fundingFee.refunds} />
        </>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  fundingFee: state.fundingFee
})

export default connect(mapStateToProps, { fetchRefundTotals, clearRefunds })(RefundSearchContainer)
